var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"subTable",staticClass:"crosstab-title"},[_c('h2',[_c('div',{staticStyle:{"text-align":"center"}},[_vm._v(" Behavioral Risk Factor Surveillance System ")]),_c('div',[_vm._v("Cross Tabulation, "+_vm._s(_vm.locations)+", "+_vm._s(_vm.years))]),_c('div',[_vm._v(_vm._s(_vm.getRowsAndColumns(_vm.reportModel)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }